module.exports = __webpack_public_path__ + "029eb6b779d58878830497659e99e8aa.png";